import Printable from './_printable'

export default class extends Printable {

  constructor () {
    super()
    this._sprite = '..'
  }

}
